import { css } from "@emotion/react";
import Skeleton from "@mui/material/Skeleton";

import { colors } from "@dotnet/telematics-design-system";

export const HierarchyTitleLoader = () => {
    const { gray200 } = colors;

    return (
        <Skeleton
            variant="rectangular"
            width={180}
            height={20}
            css={css({
                background: gray200,
                borderRadius: "6px"
            })}
        />
    );
};
